import { answerLabelForStep, LEAD_CAPTURE_FIELDS } from '@sse/shared';

const plain = value => value && typeof value === 'object' && !Array.isArray(value);
const populated = value => value !== null && value !== '' && value !== undefined && (!Array.isArray(value) || value.length > 0);
const validValue = value => ['string', 'number', 'boolean'].includes(typeof value) || value === null ||
  (Array.isArray(value) && value.every(item => typeof item === 'string'));

// Resolve only the request that the test actually sent against its own frozen
// preview definition. Authored-but-skipped questions are never fabricated here.
export function previewSubmissionResult(pkg, capture) {
  if (!plain(capture) || !plain(capture.fields) || !['chat', 'book', 'support'].includes(capture.route)) return null;
  if (JSON.stringify(capture).length > 110 * 1024 || Object.entries(capture.fields).some(([key, value]) =>
    ['__proto__', 'constructor', 'prototype'].includes(key) || !validValue(value))) return null;
  const steps = capture.route === 'chat' ? pkg.mag_macro_steps : pkg.mag_routes?.[capture.route];
  const answers = Object.entries(capture.fields).filter(([, value]) => populated(value)).map(([key, value]) => {
    const origins = (Array.isArray(steps) ? steps : []).filter(step => step?.step_columns?.includes(key));
    const field = LEAD_CAPTURE_FIELDS.find(item => item.value === key);
    // Reused legacy keys cannot identify which prompt supplied the final value.
    const label = origins.length === 1 ? answerLabelForStep(origins[0]) : field?.label || key;
    const exact = capture.selections?.[key];
    const selections = Array.isArray(exact) && exact.length && exact.every(item => typeof item === 'string') && value === exact.join(', ')
      ? exact.slice() : null;
    return { key, label, value, selections, group: field && key !== 'description' ? 'Lead details' : 'Additional answers' };
  });
  return { answers, timezone: typeof capture.scheduler_timezone === 'string' ? capture.scheduler_timezone : '' };
}

export function renderPreviewSubmissionResult(root, result) {
  root.replaceChildren(); root.open = false; root.hidden = !result;
  if (!result) return;
  const append = (parent, tag, text) => {
    const node = document.createElement(tag); node.textContent = text; parent.append(node); return node;
  };
  append(root, 'summary', `Test result · ${result.answers.length} ${result.answers.length === 1 ? 'answer' : 'answers'}`);
  const body = append(root, 'div', '');
  append(body, 'strong', 'What this submission would include');
  append(body, 'p', 'Simulation only. No lead was saved and nothing was delivered to a CRM. Contact update and delivery rules still apply.');
  for (const group of ['Lead details', 'Additional answers']) {
    const rows = result.answers.filter(answer => answer.group === group);
    if (!rows.length) continue;
    append(body, 'h4', group);
    const list = append(body, 'dl', '');
    for (const row of rows) {
      append(list, 'dt', row.label);
      const value = append(list, 'dd', '');
      if (row.selections || Array.isArray(row.value)) {
        const selections = append(value, 'ul', '');
        for (const item of row.selections || row.value) append(selections, 'li', item);
      } else append(value, 'span', String(row.value));
    }
  }
  if (!result.answers.length) append(body, 'p', 'This test request contained no completed answers.');
  if (result.timezone) append(body, 'p', `Requested time zone: ${result.timezone}`);
  append(body, 'p', 'Only answers included in this test request are shown. Skipped questions and choices used only for navigation are omitted.');
}
